import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Download, X } from "lucide-react";
import { useAppUpdate } from "hooks/useAppUpdate";

// Floating card shown once a desktop update has finished downloading. The
// restart is always the user's call; "Later" hides it and the update installs
// on the next normal quit.
const UpdateReadyCard = () => {
  const { status, install } = useAppUpdate();
  const [dismissedVersion, setDismissedVersion] = useState(null);

  const show =
    status.state === "downloaded" && status.version !== dismissedVersion;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.2 }}
          className="fixed bottom-4 right-4 z-[1000] w-[320px] rounded-xl border border-[#F3F4F6] bg-white p-4 shadow-lg"
        >
          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#FEF3E7]">
              <Download size={16} className="text-[#E07A3A]" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-[#111827]">
                Update ready
              </p>
              <p className="mt-0.5 text-[13px] text-[#6B7280]">
                Version {status.version} is ready. Restart to finish updating.
              </p>
            </div>
            <button
              onClick={() => setDismissedVersion(status.version)}
              className="text-[#9CA3AF] transition hover:text-[#374151]"
              aria-label="Dismiss"
            >
              <X size={16} />
            </button>
          </div>
          <div className="mt-3 flex justify-end gap-2">
            <button
              onClick={() => setDismissedVersion(status.version)}
              className="rounded-lg px-3 py-1.5 text-[13px] font-medium text-[#374151] transition hover:bg-[#F3F4F6]"
            >
              Later
            </button>
            <button
              onClick={install}
              className="rounded-lg bg-[#E07A3A] px-3 py-1.5 text-[13px] font-medium text-white transition hover:bg-[#D66B2E]"
            >
              Restart now
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpdateReadyCard;
